import {getField} from 'vuex-map-fields';
import api from "./../../../util/api";
import {apiAction, commonMutations, commonState} from "./../../common";

const state = () => ({
    ...commonState(),
    pipes:[],
});

let getListData = state => {
    return state.pipes.current_page ? state.pipes.data : state.pipes;
};

// getters
const getters = {
    getField,
};

// actions
const actions = {
    getPipes:apiAction(async ({ commit, rootGetters }, filters)=>{
        let result = await api.pipes.get(rootGetters['account/token'], rootGetters['account/companyId'], filters)
        commit('update', result);
    })
};

// mutations
const mutations = {
    ...commonMutations,
    push:(state, pipe)=>{
        getListData(state).push(pipe)
    },
    replace:(state, pipe)=>{
        let index = getListData(state).findIndex(t=>t.id===pipe.id);
        getListData(state).splice(index, 1, pipe);
    },
    delete:(state, automationList)=>{
        let index = getListData(state).findIndex(t=>t.id===automationList.id);
        getListData(state).splice(index, 1);
    },
    update:(state, pipes)=>{
        state.pipes = pipes;
    },
};


export default {
    namespaced: true,
    modules:{

    },
    state,
    getters,
    actions,
    mutations
};